import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'keys'})
export class KeysPipe implements PipeTransform {
  transform(value, args?: string[]): any {
    // @ts-ignore
    return Object.keys(value);
  }
}
